import React, { useEffect, useRef } from "react";
import { getStageMessage } from "./getStageMessage";
import "./meetingdetails.css";
import GetImage from "../../components/getimage/Getimage";
import getMeetingTime from "./utility/getMeetingTime";
import { getDateLabel } from "./utility/getDateLabel";
import attendees from "../../assets/teammeeting.png"
const Detailssection = ({ details, userID,meetingInfo }) => {
console.log(details,"meetingInfo")
const containerRef = useRef(null);
useEffect(() => {
  if (!details?.length) return null;
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [details]);
  if (!details?.length) return null;


const groupedData = details.reduce((acc, item) => {
  const label = getDateLabel(item.logtime);

  if (!acc[label]) {
    acc[label] = [];
  }

  acc[label].push(item);
  return acc;
}, {});

  return (
    <div  ref={containerRef} style={{height:"76vh" , overflowY:"auto" , paddingBottom:"10vh"}}>
     {meetingInfo?.attendees !== -1 && meetingInfo?.attendance !== 1 && (
  <div
    style={{
      position: "sticky",
      top: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px", 
      padding: "4px 0",
      zIndex: 10
    }}
  >
    <div style={{backgroundColor:"gray" , color:"white"}}>
      <p style={{ margin: 0, fontWeight: 500 }}>
      {meetingInfo?.attendance}/{meetingInfo?.attendees}
    </p>
    <img
      src={attendees}
      className="img-fluid meetinggroupimg"
      alt="Attendees"
      style={{ width: "20px", height: "20px" }} 
    />
      </div>
    
  </div>
)}
    <div style={{marginTop:"20px"}}>
  {Object.keys(groupedData).map((dateLabel) => (
    <div key={dateLabel}>

     
      <div  style={{display:"flex", justifyContent:"center"}}>
        <p className="date-header" >
        {dateLabel}
            </p>
      </div>

     
      {groupedData[dateLabel].map((item, index) => {

        const stageData = getStageMessage({
          actionType: item?.actiontype,
          actionByEmpID: item?.actionbyempid,
          actionByEmpName: item?.actionbyempname,
          createdByEmpID: meetingInfo?.createdbyempid,
          createdByEmpName: meetingInfo?.createdbyempname,
          hostedByEmpID: meetingInfo?.hostempid,
          hostedByEmpName: meetingInfo?.hostempname,
          userID,
          data: item?.data,
          details:meetingInfo
        });

        return (
          <div key={index} className="detailsitem">

            <div className="image-row" style={{display:"flex", justifyContent:"center"}}>
              {stageData.leftImage && (
                <GetImage
                  imgID={stageData.leftImage}
                  width="40px"
                  height="40px"
                />
              )}

              {stageData.showRight &&
                stageData.rightImage &&
                stageData.rightImage != stageData.leftImage && (
                  <GetImage
                    imgID={stageData.rightImage}
                    width="40px"
                    height="40px"
                  />
                )}
            </div>

<div
  style={{
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }}
>
  
  <div
    style={{
      position: "absolute",
      left: 0,
      right: "50%",
      borderTop: "1px solid #ff4d4f",
      marginRight: "80px",
    }}
  />


  <div
    style={{
      color: "red",
      fontWeight: "500",
      whiteSpace: "nowrap",
      textAlign: "center",
      zIndex: 1,
      background: "white",
      padding: "0 8px",
    }}
    dangerouslySetInnerHTML={{ __html: stageData.message }}
  />


  <div
    style={{
      position: "absolute",
      left: "50%",
      right: "70px",
      borderTop: "1px solid #ff4d4f",
    }}
  />


  <div
    style={{
      position: "absolute",
      right: 0,
      color: "gray",
      fontSize: "12px",
      whiteSpace: "nowrap",
      background: "white",
      padding: "0 5px",
    }}
  >
    {getMeetingTime(item.logtime.date)}
  </div>
</div>

          {item.actiontype==3  && (
  <div
  className="summarytest"
    dangerouslySetInnerHTML={{
      __html: item.data,
    }}
  />
)}
    


          </div>
        );
      })}
    </div>
  ))}
</div>


    </div>
  );
};

export default Detailssection;